module.exports = __webpack_public_path__ + "static/media/favicon.fa4783d1.png";